module.exports = __webpack_public_path__ + "img/BanoshisBlessing.a2407665.png";